// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SMgKi","delete":"styles_delete__qZNQj","update":"styles_update__2Lutd","add":"styles_add__33Wrs"};